import {useWindowDimensions, View} from 'react-native';
import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {AnalyticsScreenProps} from 'navigations/AnalyticsFlow';
import {useTheme} from 'contexts/ThemeContext';
import TabbarComponent from 'components/organisms/tabbar';
import {Flows, ScreenName} from 'navigations/Screens';
import {
  useClassStore,
  useLoaderStore,
  useUserStore,
} from 'contexts/StoreContext';
import NavigationHeaderWeb from 'components/organisms/navigationWeb';
import CalendarView from 'components/molecules/calendarView/index.web';
import AnalyticsLessonList from 'components/molecules/analyticsLessonList';
import {getSize} from 'helpers/getSize';
import {DEVICE_SIZES} from 'rn-responsive-styles';
import DayNavigationForWeb from 'components/molecules/dayNavigationForWeb';
import {getCurrentWeek} from 'helpers/getCurrentWeekDatePrototype';
import styleSheet from './styles';
import {StudentScheduleFormat} from 'stores/ClassStore';

const AnalyticsScreen = observer((props: AnalyticsScreenProps) => {
  const styles = styleSheet(useTheme());
  const {width} = useWindowDimensions();

  const userStore = useUserStore();
  const classStore = useClassStore();
  const loaderStore = useLoaderStore();

  const {currentDate} = classStore;

  const dataForAnalyticLessonList: StudentScheduleFormat[] =
    classStore.analyticLessonList;

  const day = currentDate ? currentDate : new Date();

  const currentDay = new Date(day);

  useEffect(() => {
    const date = new Date();
    classStore.setCurrentDate(date.toISOString());
    classStore.setWeekNumber(getCurrentWeek());

    loaderStore.startLoading();

    userStore.getCurrentUserIfNeeded().then(async () => {
      try {
        await classStore.getClasses();
        classStore.mapAndSetEventListForWeb();
      } finally {
        loaderStore.stopLoading();
      }
    });
  }, []);

  const getPrevDay = () => {
    const d = currentDay.setDate(currentDay.getDate() - 1);
    const prevDay = new Date(d).toString();

    classStore.setCurrentDate(prevDay);
  };

  const getNextDay = () => {
    const d = currentDay.setDate(currentDay.getDate() + 1);
    const nextDay = new Date(d).toString();

    classStore.setCurrentDate(nextDay);
  };

  const LeftView = (
    <>
      {width > getSize(DEVICE_SIZES.MEDIUM_DEVICE) ? (
        <View style={styles.webLeftPart}>
          <CalendarView
            onDayPress={(date: Date) => {
              classStore.setCurrentDate(date.toISOString());
            }}
            selected={new Date(day)}
          />
        </View>
      ) : null}
    </>
  );

  const RightView = (
    <View style={styles.webRightPart}>
      <DayNavigationForWeb
        currentDay={currentDay}
        onPressPrevDay={getPrevDay}
        onPressNextDay={getNextDay}
      />

      <AnalyticsLessonList
        data={dataForAnalyticLessonList}
        onPress={(id, title, classMarking, classDate) => {
          props.navigation.navigate(ScreenName.charts, {
            id: id,
            title: title,
            classMarking: classMarking,
            classDate: classDate,
          });
        }}
        isRecordingRequest={classStore.isRecordingRequest}
        onGetRecordingButtonPressed={sessionId =>
          classStore.getRecording(sessionId)
        }
      />
    </View>
  );

  return (
    <View style={styles.safeArea}>
      <NavigationHeaderWeb activeName={Flows.analyticsFlow} />
      <View style={styles.containerStyle}>
        {LeftView}
        {RightView}
      </View>
      <TabbarComponent activeName={Flows.analyticsFlow} />
    </View>
  );
});

export default AnalyticsScreen;
